import { api } from './client.js';

const root = '/admin/replenishment';

export const replenishmentApi = {
  suggestions: () => api.get(`${root}/suggestions`),
  run: () => api.post(`${root}/run`, {})
};
